import { donationModal} from "./donationModal";
import {ui } from "./ui";
import { mailchimpModal} from "./mailchimpModal";

export default {
    donationModal,
    mailchimpModal,
    ui
}